import upload from '../Services/upload';

export default (fileProps) => (dispatch) => {
  
  dispatch(upload(fileProps));

}